window.openedSidebars = [];

if (typeof MainHeader !== 'function') {
  class MainHeader extends HTMLElement {
    constructor() {
      super();
      this.mount();
    }

    mount() {
      /* -- > DRAWERS < -- */

      document.querySelectorAll('#main > div').forEach((elm) => {
        if (!elm.classList.contains('no-inert')) {
          elm.setAttribute('data-js-inert', '');
        }
      });
      window.inertElems = document.querySelectorAll('[data-js-inert]');

      // Sticky header

      if (this.hasAttribute('data-sticky-header')) {
        const stickyHeader = document.createElement('div');
        stickyHeader.classList = 'sticky-header site-header';

        if (this.classList.contains('site-header--style-one-row')) {
          stickyHeader.innerHTML = `<div class="container--large">
						<div class="${
              this.querySelector('.header__top').className
            }" style="height:calc(var(--header-logo) + var(--header-vertical-space))">
							${this.querySelector('.header__top').innerHTML}
						</div>
					</div>`;
          stickyHeader.className = `sticky-header ${this.className}`;
          stickyHeader.classList.remove('site-header--absolute');
        } else {
          stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
						${this.querySelector('.header__bottom').innerHTML}
						<div style="display:flex;gap:15px;">
							${
                this.querySelector('.area--custom-icon')
                  ? this.querySelector('.area--custom-icon').outerHTML
                  : ''
              }
							${this.querySelector('.area--search').outerHTML}
							${this.querySelector('.area--cart').outerHTML}
						</div>
					</div>
					<div class="site-header element--hide-on-portable-plus">
						${this.querySelector('.header-container--top').innerHTML}
					</div>`;
        }

        const ribbonObserver = new MutationObserver((_mutationList, observer) => {
          const osRibbon = document.querySelector('announcement-bar');

          if (osRibbon) {
            let clone = osRibbon.cloneNode(true);
            clone.classList.add('clone');
            stickyHeader.prepend(clone);
            observer.disconnect();
          } else {
          }
        });
        ribbonObserver.observe(document.body, {
          childList: true,
          subtree: true,
        });

        document.body.append(stickyHeader);

        stickyHeader.querySelectorAll('[id]').forEach((elm) => {
          setTimeout(() => {
            elm.id = `${elm.id}-sticky`;

            if (elm.id == 'logo-sticky' && elm.tagName == 'H1') {
              elm.outerHTML = elm.outerHTML.replace(/h1/gi, 'div');
            }
          }, 0);
        });
        stickyHeader.querySelectorAll('.site-nav [aria-controls]').forEach((elm) => {
          elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
        });

        window.lst = window.scrollY;
        window.lhp = 0;

        const stickyHeaderDeskBound = this.classList.contains('site-header--style-one-row')
          ? this.querySelector('.header__top')
          : this.querySelector('.header__bottom');
        const stickyHeaderMobileBound = this.querySelector('.header__top');

        const setStickyHeaderHeight = (shown) => {
          document.documentElement.style.setProperty(
            '--sticky-header-height',
            shown ? `${stickyHeader.offsetHeight}px` : '0px'
          );
          document.querySelector('sticky-add-to-cart')?.classList.toggle('sticky-atc--snap-top', !shown);
        };

        this.SCROLL_StickyHelper = () => {
          var st = window.scrollY;

          if (
            (st <= 0 ||
              (window.innerWidth >= 1024
                ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0
                : stickyHeaderMobileBound.getBoundingClientRect().top >= 0)) &&
            stickyHeader.classList.contains('show')
          ) {
            stickyHeader.classList.remove('show');
            setStickyHeaderHeight(false);
            return;
          }

          if (st < 0 || Math.abs(lst - st) <= 5) return;

          if (st > window.lhp) {
            if (st == 0 && stickyHeader.classList.contains('show')) {
              stickyHeader.classList.remove('show');
              setStickyHeaderHeight(false);
            } else if (st <= lst && !stickyHeader.classList.contains('show')) {
              window.lhp = stickyHeader.offsetTop;
              stickyHeader.classList.add('show');
              setStickyHeaderHeight(true);
            } else if (st > lst && stickyHeader.classList.contains('show')) {
              stickyHeader.classList.remove('show');
              setStickyHeaderHeight(false);
            }
          }

          window.lst = st;
        };

        window.addEventListener('scroll', this.SCROLL_StickyHelper, {
          passive: true,
        });
      }

      // drawer connections

      document.querySelectorAll('[data-js-sidebar-handle]').forEach((elm) => {
        if (elm.hasAttribute('aria-controls')) {
          const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
          elm.addEventListener('click', (e) => {
            e.preventDefault();
            elm.setAttribute('aria-expanded', 'true');
            const isCartSidebar = elmSidebar.getAttribute('data-js-site-cart-sidebar');
            const isFirstTimeRefresh = !elmSidebar.getAttribute('first-time-refresh');

            if (isCartSidebar && isFirstTimeRefresh) {
              window.cartRefresh();
              elmSidebar.setAttribute('first-time-refresh', 'true');
              console.log('First Time Refresh');
            }
            elmSidebar.show();
          });
          elm.addEventListener('keyup', (e) => {
            if (e.keyCode == window.KEYCODES.RETURN) {
              elm.setAttribute('aria-expanded', 'true');
              elmSidebar.show();
              elmSidebar.querySelector('[data-js-close]').focus();
            }
          });
        }
      });

      // closing drawers

      document.querySelectorAll('sidebar-drawer [data-js-close]').forEach((elm) => {
        elm.addEventListener('click', (e) => {
          e.preventDefault();
          if (e.target.closest('.sidebar').classList.contains('sidebar--opened')) {
            e.target.closest('.sidebar').hide();
          }
        });
      });

      const closeLastOpenedSidebar = () => {
        if (
          document.querySelector('custom-guide.active') ||
          document.querySelector('product-modal.active') ||
          document.querySelector('custom-shop-the-look.active')
        ) {
          return;
        }

        if (window.openedSidebars.length > 0) {
          const lastSidebar = window.openedSidebars[window.openedSidebars.length - 1];
          lastSidebar.hide();
        }
      };

      // Ensure the overlay element exists and add the event listener
      const siteOverlay = document.querySelector('.site-overlay');
      if (siteOverlay) {
        siteOverlay.addEventListener('click', closeLastOpenedSidebar);
      } else {
        console.error('Site overlay element not found');
      }

      document.addEventListener('keydown', (e) => {
        if (e.keyCode == window.KEYCODES.ESC) {
          closeLastOpenedSidebar();
        }
      });

      // resizing drawers

      const rootHeight = document.getElementById('root-height');
      this.RESIZE_SidebarHelper = debounce(() => {
        rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
					--window-width: ${document.body.clientWidth}px;
				}`;
      }, 200);
      window.addEventListener('resize', this.RESIZE_SidebarHelper);
      rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
				--window-width: ${document.body.clientWidth}px;
			}`;
      document.body.classList.add('header-loaded');

      // switch menu (on load and on resize)
      this._previousWidth = window.innerWidth;
      this._checkMenuWidth();
      this._checkMenuWidth();

      window.addEventListener(
        'resize',
        debounce(() => {
          this._checkMenuWidth();
        }, 200)
      );

      // submenu masonry

      document.querySelectorAll('.site-nav.style--classic .submenu-masonry').forEach((elm) => {
        if (Macy) {
          const submenuMacy = new Macy({
            container: elm,
            columns: parseInt(elm.getAttribute('data-columns')),
            margin: 30,
          });
          setTimeout(() => {
            submenuMacy.reInit();
          }, 100);
        }
      });

      // predictive search

      if (JSON.parse(document.getElementById('shopify-features').text).predictiveSearch) {
        // predictive search (sidebar)

        document.querySelectorAll('[data-js-open-search-drawer').forEach((elm) => {
          elm.addEventListener('click', (e) => {
            e.preventDefault();
            if (!document.body.classList.contains('predictive-script-loaded')) {
              document.body.classList.add('predictive-script-loaded');
              const predictiveSearchJS = document.createElement('script');
              predictiveSearchJS.src = KROWN.settings.predictive_search_script;
              document.head.appendChild(predictiveSearchJS);

              predictiveSearchJS.onload = () => {
                console.log('Predictive Search JS loaded');
                const searchForm = document.querySelector('search-form');
                if (searchForm && searchForm.input.value == '') {
                  searchForm.getEmptySearchResults();
                } else if (searchForm && searchForm.input.value.length != 0) {
                  searchForm.getSearchResults(searchForm.input.value);
                }
              };
            }
            setTimeout(() => {
              document.querySelector('#search-form-sidebar').focus();
            }, 10);
          });
        });
      } else {
        this.querySelector('search-form').addEventListener('click', (e) => {
          e.preventDefault();
          window.location.href = KROWN.settings.routes.search_url;
        });
      }

      // touch menu helpers

      const closeTouchSubmenus = (focusedElm, focusedParent = null) => {
        document.querySelectorAll('.style--classic li.focus').forEach((elm) => {
          if (!(elm === focusedElm || elm === focusedParent)) {
            elm.classList.remove('focus');
          }
        });
      };
      let babyMenuTouch = false;
      if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
        document.querySelectorAll('.style--classic .has-babymenu > a').forEach((elmLink) => {
          const elm = elmLink.parentElement;
          elmLink.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            elm.classList.toggle('focus');
            babyMenuTouch = true;
            closeTouchSubmenus(elm, elm.closest('.has-submenu'));
          });
        });
        document.querySelectorAll('.style--classic .has-submenu > a').forEach((elmLink) => {
          const elm = elmLink.parentElement;
          if (!elm.classList.contains('mega-link')) {
            elmLink.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (!babyMenuTouch) {
                elm.classList.toggle('focus');
                closeTouchSubmenus(elm);
              }
              babyMenuTouch = false;
            });
          }
        });
      }

      // tab navigation for the menu

      document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach((childEl) => {
        const elm = childEl.parentNode;

        elm.addEventListener('keydown', (e) => {
          if (e.keyCode == window.KEYCODES.RETURN) {
            if (!e.target.classList.contains('no-focus-link')) {
              e.preventDefault();
            }
            if (!elm.classList.contains('focus')) {
              elm.classList.add('focus');
              elm.setAttribute('aria-expanded', 'true');
            } else if (
              document.activeElement.parentNode.classList.contains('has-submenu') &&
              elm.classList.contains('focus')
            ) {
              elm.classList.remove('focus');
              elm.setAttribute('aria-expanded', 'true');
            }
          }
        });

        if (elm.querySelector('.submenu-holder > li:last-child a')) {
          elm
            .querySelector('.submenu-holder > li:last-child a')
            .addEventListener('focusout', (e) => {
              if (elm.classList.contains('focus')) {
                elm.classList.remove('focus');
                elm.setAttribute('aria-expanded', 'false');
              }
            });
        }
      });

      document
        .querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a')
        .forEach((childEl) => {
          const elm = childEl.parentNode;

          elm.addEventListener('keydown', (e) => {
            if (e.keyCode == window.KEYCODES.RETURN) {
              if (!e.target.classList.contains('no-focus-link')) {
                e.preventDefault();
              }
              if (!elm.classList.contains('focus')) {
                elm.classList.add('focus');
                elm.setAttribute('aria-expanded', 'true');
              } else {
                elm.classList.remove('focus');
                elm.setAttribute('aria-expanded', 'false');
              }
            }
          });

          if (elm.querySelector('.babymenu li:last-child a')) {
            elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', (e) => {
              if (elm.parentNode.classList.contains('focus')) {
                elm.parentNode.classList.remove('focus');
                elm.parentNode.setAttribute('aria-expanded', 'false');
              }
            });
          }
        });
    }

    unmount() {
      window.removeEventListener('resize', this.RESIZE_SidebarHelper);
      window.removeEventListener('scroll', this.SCROLL_StickyHelper);
      document.querySelector('.sticky-header')?.remove();
    }

    _checkMenuWidth() {
      const header = document.querySelector('.header__top');
      if (!header) return;

      const classicMenu = header.querySelector('.area--menu-classic');
      if (!classicMenu) return;

      let totalWidthWithoutClassicMenu = 0;
      for (const child of header.children) {
        if (!child.classList.contains('area--menu-classic')) {
          totalWidthWithoutClassicMenu += child.scrollWidth;
        }
      }

      let spaceAvailableForClassicMenu = header.scrollWidth - totalWidthWithoutClassicMenu;

      let totalWidthOfMenuChildren = 0;
      for (const child of classicMenu.children) {
        totalWidthOfMenuChildren += child.scrollWidth;
      }

      if (window.innerWidth > 767) {
        if (totalWidthOfMenuChildren > spaceAvailableForClassicMenu) {
          header.classList.remove('site-header--menu-classic');
          header.classList.add('site-header--menu-minimal');
        } else {
          header.classList.remove('site-header--menu-minimal');
          header.classList.add('site-header--menu-classic');
        }
      }
    }

    _adjustNavLayout() {
      if (
        this.querySelector('.site-nav') &&
        this.querySelector('.site-nav').classList.contains('style--classic')
      ) {
        if (this.querySelector('nav > ul').scrollWidth > this.querySelector('nav').offsetWidth) {
          this.classList.add('site-header--swap-menu-style');
          document.body.classList.remove('header--has-two-rows');
          let header = document.getElementById('site-header');
          let twoRowsDetected = header.querySelectorAll('[class*="two-rows"]');
          twoRowsDetected.forEach((el) => {
            el.className = el.className.replace('two-rows', 'one-row');
          });
        }
      }
    }
  }

  if (typeof customElements.get('main-header') == 'undefined') {
    customElements.define('main-header', MainHeader);
  }
}

if (typeof SidebarDrawer !== 'function') {
  class SidebarDrawer extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[data-js-close]').addEventListener('click', () => {
        this.hide();
      });
      this.isOpen = false;
    }

    show() {
      if (this.isOpen) return;
      this.isOpen = true;

      document.body.classList.add('sidebar-opened');
      if (this.classList.contains('sidebar--right')) {
        document.body.classList.add('sidebar-opened--right');
      } else if (this.classList.contains('sidebar--left')) {
        document.body.classList.add('sidebar-opened--left');
      }
      if (
        this.id == 'site-cart-sidebar' &&
        document.getElementById('cart-recommendations-sidebar')
      ) {
        document.querySelector('#cart-recommendations-sidebar css-slider')?.resetSlider();
      } else if (this.id == 'site-menu-sidebar' && document.querySelectorAll('css-slider')) {
        setTimeout(() => {
          document.querySelectorAll('css-slider').forEach((slider) => {
            slider.resetSlider(true, false);
          });
        }, 300);
      }

      this.style.display = 'grid';
      requestAnimationFrame(() => {
        this.classList.add('sidebar--opened');
        window.inertElems.forEach((elm) => {
          elm.setAttribute('inert', '');
        });
        window.openedSidebars.push(this);
      });

      // Ensure the overlay is visible
      const siteOverlay = document.querySelector('.site-overlay');
      if (siteOverlay) {
        siteOverlay.style.display = 'block';
      }
    }

    hide() {
      if (!this.isOpen) return;
      this.isOpen = false;

      this.classList.remove('sidebar--opened');

      const index = window.openedSidebars.indexOf(this);
      if (index > -1) {
        window.openedSidebars.splice(index, 1);
      }

      if (window.openedSidebars.length === 0) {
        document.body.classList.remove(
          'sidebar-opened',
          'sidebar-opened--left',
          'sidebar-opened--right'
        );
        if (
          !document.querySelector('custom-guide.active') &&
          !document.querySelector('product-modal.active') &&
          !document.querySelector('custom-shop-the-look.active')
        ) {
          window.inertElems.forEach((elm) => {
            elm.removeAttribute('inert');
          });
        }
        // Hide the overlay when no sidebars are open
        const siteOverlay = document.querySelector('.site-overlay');
        if (siteOverlay) {
          siteOverlay.style.display = 'none';
        }
      }

      document
        .querySelector(`[aria-controls="${this.id}"]`)
        ?.setAttribute('aria-expanded', 'false');

      this.addEventListener(
        'transitionend',
        () => {
          if (!this.isOpen) {
            this.style.display = 'none';
          }
        },
        { once: true }
      );
    }
  }

  if (typeof customElements.get('sidebar-drawer') == 'undefined') {
    customElements.define('sidebar-drawer', SidebarDrawer);
  }
}

if (typeof MobileNavigation !== 'function') {
  class MobileNavigation extends HTMLElement {
    constructor() {
      super();

      this.querySelectorAll('.has-submenu > a').forEach((elm) => {
        elm.addEventListener('click', (e) => {
          e.preventDefault();
          const menuItem = e.target.closest('li');
          this._toggleMenu(menuItem);
        });
      });

      this.querySelectorAll('.has-babymenu > a').forEach((elm) => {
        elm.addEventListener('click', (e) => {
          e.preventDefault();
          const menuItem = e.target.closest('li');
          this._toggleMenu(menuItem);
        });
      });

      this.querySelectorAll('.submenu-back a').forEach((elm) => {
        elm.addEventListener('click', (e) => {
          e.preventDefault();
          const menuItem = e.target.closest('li.opened');
          if (menuItem) {
            this._toggleMenu(menuItem);
          }
        });
      });
    }

    _toggleMenu(menuItem) {
      if (!menuItem) return;

      const isOpen = menuItem.classList.contains('opened');

      if (isOpen) {
        // Close the menu (but keep children state intact)
        menuItem.classList.remove('opened');
        menuItem.setAttribute('aria-expanded', 'false');
      } else {
        this._closeSiblingMenus(menuItem);

        menuItem.classList.add('opened');
        menuItem.setAttribute('aria-expanded', 'true');
      }
    }

    _closeMenu(menuItem) {
      menuItem.classList.remove('opened');
      menuItem.setAttribute('aria-expanded', 'false');

      menuItem.querySelectorAll('li.opened').forEach((nestedItem) => {
        nestedItem.classList.remove('opened');
        nestedItem.setAttribute('aria-expanded', 'false');
      });
    }

    _closeSiblingMenus(menuItem) {
      const parentList = menuItem.parentElement;
      if (!parentList) return;

      Array.from(parentList.children).forEach((sibling) => {
        if (sibling !== menuItem && sibling.classList.contains('opened')) {
          this._closeMenu(sibling);
        }
      });

      const nav = menuItem.closest('nav');
      if (nav) {
        nav.querySelectorAll('li.opened').forEach((openedMenu) => {
          if (
            openedMenu !== menuItem &&
            !openedMenu.contains(menuItem) &&
            !menuItem.contains(openedMenu)
          ) {
            this._closeMenu(openedMenu);
          }
        });
      }
    }
  }

  if (typeof customElements.get('mobile-navigation') == 'undefined') {
    customElements.define('mobile-navigation', MobileNavigation);
  }
}

window.trigger = {
  klaviyo: (id) => {
    const openPopup = () => {
      
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', id.toString()]);
    };

    openPopup();
  },
  postscript: (id) => {
    const openPopup = () => {
      id = id.toString();
      window.postscript.popups.open(id, {
        activePopupBehavior: 'ALWAYS_DISMISS',
        respectPopupStatus: false,
      });
    };

    if (
      window.postscript &&
      typeof window.postscript === 'object' &&
      typeof window.postscript.popups?.find === 'function' &&
      typeof window.postscript.popups?.open === 'function'
    ) {
      console.log('Popup found');
      openPopup();
    } else {
      console.log('Popup not found');
      window.addEventListener('postscriptReady', openPopup, { once: true });
    }
  },

  guide: (...args) => {
    const sectionId = args.length > 1 ? args[args.length - 1] : 'helper-page-content';
    const url = args.length > 1 ? args.slice(0, -1).join(':') : args[0];
    const trigger = document.activeElement?.matches?.('a[href^="#trigger:guide"]')
      ? document.activeElement
      : null;

    const openGuide = () => {
      window.CustomGuideOpener.open(url, sectionId, trigger);
    };

    if (window.CustomGuideOpener) {
      openGuide();
    } else {
      window.addEventListener('customGuideReady', openGuide, { once: true });
    }
  },

  /**
   * Shop the look drawer. Hash passes everything after `shopTheLook:` as colon-split args.
   *
   * - `#trigger:shopTheLook` — current pathname + `helper-shop-the-look`
   * - `#trigger:shopTheLook:/pages/shop-the-look/your-handle` — fetch kit HTML from that page (Section API)
   * - `#trigger:shopTheLook:/products/handle:helper-shop-the-look` — explicit path + section id
   * - `#trigger:shopTheLook:helper-shop-the-look` — section id only (path = current page)
   * - `#trigger:shopTheLook:/products/ANCHOR||/pages/look-metaobject-path` — anchor product fetch (carousel from
   *   `custom.looks`) with the **clicked look first** in the preview carousel (`||` separates anchor path from look path).
   *
   * Links may omit the leading slash (`pages/...`); same-origin fetch must still target `/pages/...`,
   * not the current route (e.g. `/collections/...`).
   *
   * Note: no default on `sectionId` — otherwise a single-arg section override is mistaken for both path + sid.
   */
  shopTheLook: (pageUrl, sectionId) => {
    const open = () => {
      let path = pageUrl != null && pageUrl !== "" ? String(pageUrl).trim() : "";
      let sid =
        sectionId != null && sectionId !== "" ? String(sectionId).trim() : "";
      let activeLookPath = "";

      if (path.includes("||")) {
        const parts = path
          .split("||")
          .map((s) => s.trim())
          .filter(Boolean);
        path = parts[0] || "";
        activeLookPath = parts[1] || "";
      }

      if (path && !path.startsWith("/")) {
        if (path.includes("/")) {
          path = `/${path}`;
        } else {
          sid = path;
          path = "";
        }
      }

      if (!path) {
        path = window.location.pathname;
      }

      if (!sid) {
        sid = "helper-shop-the-look";
      }

      window.ShopTheLookOpener.open(path, sid, activeLookPath);
    };

    if (window.ShopTheLookOpener) {
      open();
    } else {
      window.addEventListener('shopTheLookDialogReady', open, { once: true });
    }
  },
};

((check) => {
  addEventListener('hashchange', check);
  addEventListener('popstate', check);
  check();
})(() => {
  const match = location.hash.match(/^#trigger:([^:]+)(?::(.+))?$/);
  if (!match) return;

  const [, action, params = ''] = match;
  const fn = window.trigger[action];

  if (fn) {
    fn(...params.split(':'));
    history.replaceState(null, '', location.pathname + location.search);
  }
});
